module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0